import * as React from 'react';
import { WorkspaceRole } from '../../../enums/WorkspaceRole';
import { FieldProps } from '../../MetadataForm/metadataFormField';

export const Roles = Object.values(WorkspaceRole);

export const RoleField = ({
  updater,
  field,
  data,
  disabled
}: Partial<FieldProps>) => {
  const { updateField } = updater;
  const dataProps = data?.props || {};
  const selected = dataProps[field.field] || [];
  return (
    <div className="role-field">
      {Roles.map((role, idx) => {
        return (
          <div key={idx}>
            <input
              type="checkbox"
              id={'roleCB_' + idx}
              checked={selected.includes(role)}
              disabled={disabled}
              onChange={e => {
                if (e.target.checked) {
                  updateField(field, [...selected, role]);
                } else {
                  updateField(
                    field,
                    selected.filter(r => r != role)
                  );
                }
              }}
            />
            <label htmlFor={'roleCB_' + idx}>{role}</label>
          </div>
        );
      })}
    </div>
  );
};
